import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

const imageData = [
    {
        src: `${process.env.PUBLIC_URL}/media/gallery/one.jpg`,
        alt: "one",
    },
    {
        src: `${process.env.PUBLIC_URL}/media/gallery/two.jpg`,
        alt: "two",
    },
];

const Awards = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
    }, []);

    return (
        <div className="container mx-auto shadow rounded-lg p-5 ubuntu-regular">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-left">
                Gallery
            </h2>

            {/* Small Screen Version (AOS zoom-in only, faster autoplay) */}
            <div className="block lg:hidden" data-aos="zoom-in">
                <Swiper
                    spaceBetween={16}
                    slidesPerView="auto"
                    centeredSlides={true}
                    loop={false}
                    autoplay={{ delay: 800, disableOnInteraction: true }} // Faster autoplay for small screens
                    modules={[Autoplay]}
                    className="carousel rounded-box p-4 cursor-pointer"
                >
                    {imageData.map((image, index) => (
                        <SwiperSlide
                            key={index}
                            className="carousel-item w-auto"
                        >
                            <img
                                src={image.src}
                                alt={image.alt}
                                className="rounded-box h-60 mx-auto" // Smaller image height for small screens
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Large Screen Version (Original settings) */}
            <div className="hidden lg:block" data-aos="flip-up">
                <Swiper
                    spaceBetween={16}
                    slidesPerView="auto"
                    centeredSlides={true}
                    loop={false}
                    autoplay={{ delay: 1000, disableOnInteraction: true }} // Original autoplay delay for large screens
                    modules={[Autoplay]}
                    className="carousel rounded-box p-4 cursor-pointer"
                >
                    {imageData.map((image, index) => (
                        <SwiperSlide
                            key={index}
                            className="carousel-item w-auto"
                        >
                            <img
                                src={image.src}
                                alt={image.alt}
                                className="rounded-box lg:h-[70vh] mx-auto"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default Awards;
